import React, { useCallback, useEffect, useState } from "react";
import { Grid, Button, Typography, makeStyles } from "@material-ui/core";
import Modal from "../../../../../components/modals/Modal";
import { agencySelectors, authSelectors, useSelector } from "../../../../../state";

export const useStyles = makeStyles((theme) => ({
  title: {
    color: "#000000",
    textTransform: "uppercase",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: 0.12,
    marginBottom: 20,
    textAlign: "center",
  },
  text: {
    color: "#000000",
    fontSize: 16,
    letterSpacing: 0,
    maxWidth: 800,
    marginBottom: 10,
  },
}));

const LocationUpdateConfirmationModal = (props) => {
  const { open, setOpen, setUpdateLocation } = props;
  const openedAppointment = useSelector(agencySelectors.openedAppointment);
  const activeEntity = useSelector(authSelectors.activeEntity);
  const classes = useStyles();
  const [location, setLocation] = useState("unknown");

  useEffect(() => {
    if (openedAppointment?.medical_facility_profile?.entity) {
      const { address, city, state } = openedAppointment.medical_facility_profile.entity;
      setLocation(`${city}, ${state} - ${address}`);
    }
  }, [openedAppointment]);
  const handleCloseModal = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Modal open={open} handleClose={() => setOpen(false)}>
      <Typography className={classes.title}>Confirm Appoinment Location and Check In</Typography>
      <Typography className={classes.text}>
        This appointment is scheduled at {openedAppointment?.medical_facility_profile?.entity?.name}
        : {location}. Would you like to change it to your current facility ({activeEntity.name})?
        Please note that all chat messages linked to the original facility will be archived and no
        longer visible.
      </Typography>
      <Grid container justifyContent="space-between" spacing={1}>
        <Grid item>
          <Button
            color="primary"
            size="large"
            onClick={handleCloseModal}
            style={{ textTransform: "capitalize" }}
          >
            Don't check in
          </Button>
        </Grid>
        <Grid item>
          <div>
            <Button
              color="primary"
              size="large"
              onClick={() => setUpdateLocation(false)}
              style={{ textTransform: "capitalize" }}
            >
              Keep original
            </Button>
            <Button
              color="primary"
              size="large"
              onClick={() => setUpdateLocation(true)}
              style={{ textTransform: "capitalize" }}
            >
              Update location
            </Button>
          </div>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default LocationUpdateConfirmationModal;
